import {useContext} from "react";
import {GlobalContext} from "../../utils/context/GlobalContextProvider.jsx";
import {ProjectPermission} from "../../api/authority/generated/index";
import {SensitiveMetric} from "../../api/authority/generated/index";

export function useIsAdministrator() {
    let {context} = useContext(GlobalContext);
    return context?.currentIdentity?.user?.isAdministrator === true;
}

export function useHasSensitiveMetric() {
    let isAdministrator = useIsAdministrator();

    return (metric, projectOrProjectUser = null) => {
        if (isAdministrator || projectOrProjectUser?.isOwner === true) {
            return true;
        }

        return projectOrProjectUser?.sensitiveMetrics?.includes(metric) ?? false;
    };
}

export function useHasReport() {
    let isAdministrator = useIsAdministrator();

    return (report, projectOrProjectUser = null) => {
        if (isAdministrator || projectOrProjectUser?.isOwner === true) {
            return true;
        }

        return projectOrProjectUser?.allowedReports?.includes(report) ?? false;
    };
}

export function useHasLegacyReport() {
    let isAdministrator = useIsAdministrator();

    return (report, projectOrProjectUser = null) => {
        if (isAdministrator || projectOrProjectUser?.isOwner === true) {
            return true;
        }

        return projectOrProjectUser?.allowedLegacyReports?.includes(report) ?? false;
    };
}

export {SensitiveMetric};

export function useHasPermission() {
    let isAdministrator = useIsAdministrator();

    return (permission, projectOrProjectUser = null) => {
        if (isAdministrator) {
            return true;
        }

        if (projectOrProjectUser !== null) {
            return projectOrProjectUser.isOwner === true
                || projectOrProjectUser.permissions.includes(permission);
        }

        return false;
    };
}
